import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import { PANELS } from '@helpers/constants'
import AddStudentToSchoolResourcePanel from '.'
import { useDemoResources } from '@hooks/useDemoResources'
import { useUpdateDemoSchoolGroup } from '@hooks/mutations/useUpdateDemoSchoolGroup'

const AddStudentToDemoSchoolGroupPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const [demoSchoolGroup, setDemoSchoolGroup] = useState()
  const [students, setStudents] = useState()
  const {
    panels: {
      panelData: { schoolGroupId },
    },
  } = state
  const { demoSchoolGroups, demoSchoolClasses } = useDemoResources()
  const { post } = useUpdateDemoSchoolGroup()

  useEffect(() => {
    if (demoSchoolGroups.length > 0 && schoolGroupId) {
      const demoSchoolGroup = demoSchoolGroups.find(dsg => dsg.id === schoolGroupId)
      const allStudents = demoSchoolClasses.flatMap(sc => sc.students)

      setDemoSchoolGroup(demoSchoolGroup)
      setStudents(allStudents.filter(student => !demoSchoolGroup.students.some(sgStudent => sgStudent.id === student.id)))
    }
  }, [demoSchoolGroups, schoolGroupId])

  const onSubmit = async (data) => {
    const studentIdsToConnect = data.students.reduce(
      (acc, student) =>
        Object.prototype.hasOwnProperty.call(student, 'value')
          ? [...acc, student.value]
          : acc,
      []
    )

    const res = await post({
      id: schoolGroupId,
      students: { connect: studentIdsToConnect },
    })

    if (res.success) dispatch(closePanel(PANELS.ADD_STUDENT_TO_DEMO_SCHOOL_GROUP))
  }

  if (!demoSchoolGroups || !students) return null

  return (
    <AddStudentToSchoolResourcePanel
      resource={demoSchoolGroup}
      handleSubmit={onSubmit}
      students={students}
      panelType={PANELS.ADD_STUDENT_TO_DEMO_SCHOOL_GROUP}
    />
  )
}

export default AddStudentToDemoSchoolGroupPanel
